// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const StarIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Star/solid"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m10 0 .008 9.419a1 1 0 0 0 .5.864L18.66 15l-8.16-4.702a1 1 0 0 0-1 0L1.34 15l8.153-4.716a1 1 0 0 0 .499-.865L10 0Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}))));
export default StarIcon;